import React from 'react';
import { ScrollView, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import RouteMap from '../../../components/RouteMap';
import Accordion from '../../../components/Accordion';

interface DetectionDetailsProps {
    detectionRoutes: { name: string; cameras: CameraMap[]; }[];
}

export default function DetectionRoutes({ detectionRoutes }: DetectionDetailsProps) {
    const { styles } = useStyles(styleSheet);

    const renderRouteContent = (route: { name: string; cameras: CameraMap[]; }) => {
        return (
            <View style={{ width: '100%', height: '100%' }}>
                <RouteMap cameraPositions={route.cameras} useFullscreen/>
            </View>
        );
    };

    return (
        <View style={styles.cardList}>
            <ScrollView>
                <Accordion
                    tableStyle
                    items={detectionRoutes.map(r => {
                        return {
                            title: r.name,
                            content: renderRouteContent({name: r.name, cameras: r.cameras})
                        };
                    })}
                />
            </ScrollView>
        </View >
    );
}

const styleSheet = createStyleSheet((theme) => ({
    cardList: {
        flex: 1,
        flexDirection: 'row',
        gap: 15,
        borderTopWidth: 1,
        borderColor: theme.colors.dataTable.border,
        rowGap: 8,
        paddingVertical: 10
    }
}));
